// extracted by mini-css-extract-plugin
export var bodyRow = "_g1-d";
export var cardColumns = "_g1-e";
export var ellipsesOverflow = "_g1-2";
export var flatBottomCorners = "_g1-3";
export var flatTopCorners = "_g1-4";
export var headerActionsDropdown = "_g1-f";
export var headerBottomRow = "_g1-c";
export var headerTopRow = "_g1-b";
export var orderDetailsWrapper = "_g1-0";
export var orderInfoContainer = "_g1-1";
export var productDetails = "_g1-9";
export var productImage = "_g1-5";
export var responsiveTable = "_g1-8";
export var shipmentContainer = "_g1-a";
export var tableBottomLeft = "_g1-6";
export var tableBottomRight = "_g1-7";